import { ThemeEvents } from '@theme/events';

/**
 * Bascule le message "En stock" / "En rupture de stock" du bloc date de
 * livraison quand la variante sélectionnée change, sans recharger la page.
 */
class ProductDeliveryStock extends HTMLElement {
  connectedCallback() {
    const section = this.closest('section, dialog, .shopify-section, [id^="shopify-section-"]');
    if (!section) return;

    this._section = section;
    section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    this._section?.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    this._section = null;
  }

  handleVariantUpdate = (event) => {
    const { resource, data } = event.detail || {};
    const productId = data?.newProduct?.id ?? data?.productId;

    if (productId && this.dataset.productId && String(productId) !== this.dataset.productId) return;

    const available = Boolean(resource?.available);
    const availableEl = this.querySelector('[data-delivery-available]');
    const unavailableEl = this.querySelector('[data-delivery-unavailable]');

    if (availableEl) availableEl.hidden = !available;
    if (unavailableEl) unavailableEl.hidden = available;
  };
}

if (!customElements.get('product-delivery-stock')) {
  customElements.define('product-delivery-stock', ProductDeliveryStock);
}
